import {
  useEffect, useMemo, useState,
} from 'react';
import { objectsAlphabetically } from '~/_shared/utils/sort';
import { type Member } from '~/clientTeamManagement/teamManagementModal/teamManagement.types';
import { useGetMembers } from '~/clientTeamManagement/teamManagementModal/useTeamManagement';

export const useGetMemberListings = (clientId: number | null) => {
  const [resultData, setResultData] = useState<Member[]>([]);
  const { isLoading, error, data, invokeAjax: getMembers } = useGetMembers(clientId);

  const processedData = useMemo(() => (data ? {
    ...data,
    members: data.members.filter(i => i && i.id),
  } : null), [data]);

  useEffect(() => {
    getMembers();
  }, [getMembers]);

  useEffect(() => {
    if (!processedData) {
      return;
    }

    const newResultData = [...processedData.members].sort(objectsAlphabetically(member => member.name));

    setResultData(newResultData);
  }, [processedData]);

  return {
    isLoading,
    error,
    data: processedData,
    members: resultData,
  };
};
